module.exports = __webpack_public_path__ + "img/mariage-lazy.6c5de8c1.jpg";